// packages/ui/mui/theme.ts
"use client";
import { createTheme } from "@mui/material/styles";
import colors from "./Theme/base/colors";
import typographyStyles from "./Theme/base/typography";
import breakpoints from "./Theme/base/breakpoints";
import input from "./Components/form/input";
import inputLabel from "./Components/form/inputLabel";
import inputOutlined from "./Components/form/inputOutlined";
import select from "./Components/form/select";
import button from "./Components/button";

const theme = createTheme({
  breakpoints: { ...breakpoints },
  typography: { ...typographyStyles },

  palette: {
    // ── MUI standard keys ─────────────────────────────────
    // MUI runs decomposeColor() on these — hex only, no CSS vars
    primary: {
      main: colors.brand.main,
      light: colors.brand.medium,
      dark: colors.brand.pressed,
      contrastText: "#FFFFFF",
    },
    error: {
      main: colors.error.main,
      light: colors.error.medium,
      dark: "#B00020",
      contrastText: "#FFFFFF",
    },
    warning: {
      main: colors.warning.main,
      light: colors.warning.light,
      dark: "#7A3A00",
      contrastText: "#FFFFFF",
    },
    success: {
      main: colors.success.main,
      light: colors.success.light,
      dark: "#0A3D20",
      contrastText: "#FFFFFF",
    },
    info: {
      main: colors.info.main,
      light: colors.info.light,
      dark: "#0D2475",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: colors.text.main,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.default,
    },
    divider: colors.border.main,

    // ── Custom keys (Vericap-specific) ─────────────────────
    // These are passed through by MUI without colour processing
    // Still keep hex here for consistency — CSS vars go in sx/CSS only
    brand: colors.brand,
    vc: colors.border,
    vcText: colors.text,
    vcBg: colors.background,
    status: colors.status,
  } as any, // 'as any' needed for custom palette keys with TypeScript

  components: {
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiSelect: { ...select },
    MuiButton: { ...button },
  },
});

export default theme;
